var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcellence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.1665 5.00317H35.8332",
    stroke: "#493158",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5.00317V23.3349C7.5 27.2163 8.21765 28.4838 11.5459 30.4808L16.57 33.4953C18.2412 34.4978 19.0767 34.9993 20 34.9993C20.9233 34.9993 21.7588 34.4978 23.43 33.4953L28.4542 30.4808C31.7823 28.4838 32.5 27.2163 32.5 23.3349V5.00317",
    stroke: "#493158",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0077 13.3424L22.0342 15.4125C22.1742 15.7007 22.5475 15.9771 22.8624 16.03L24.723 16.3417C25.9129 16.5416 26.1929 17.412 25.3355 18.2707L23.889 19.729C23.644 19.976 23.5099 20.4525 23.5857 20.7935L23.9999 22.599C24.3264 24.028 23.574 24.5808 22.32 23.834L20.576 22.793C20.261 22.6048 19.7419 22.6048 19.4212 22.793L17.6772 23.834C16.429 24.5808 15.6707 24.0222 15.9973 22.599L16.4115 20.7935C16.4873 20.4525 16.3531 19.976 16.1082 19.729L14.6617 18.2707C13.8101 17.412 14.0842 16.5416 15.2741 16.3417L17.1347 16.03C17.4439 15.9771 17.8172 15.7007 17.9572 15.4125L18.9837 13.3424C19.5437 12.2192 20.4535 12.2192 21.0077 13.3424Z",
    stroke: "#493158",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcellence);
export default __webpack_public_path__ + "static/media/Excellence.0f0e2809a5e2b4ca3deaa546dc59965c.svg";
export { ForwardRef as ReactComponent };